import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RiskAssessmentResponse } from './types';

interface Props {
  data: RiskAssessmentResponse;
  compact?: boolean;
}

const RiskAssessmentView: React.FC<Props> = ({ data, compact = false }) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="bg-red-50 dark:bg-red-900/20 p-6 rounded-lg">
        <h2 className="text-2xl font-bold mb-2">Risk & Renewal Assessment</h2>
        {data.message && !data.risks?.length && (
          <p className="text-foreground">{data.message}</p>
        )}
      </div>

      {(data.risks || []).map((risk) => (
        <div key={risk.customer_id} className="border border-red-200 dark:border-red-800 rounded-lg p-6 bg-card">
          <button
            type="button"
            onClick={() => navigate(`/customers/${risk.customer_id}`)}
            className="text-lg font-semibold text-primary hover:underline"
          >
            {risk.customer_name}
          </button>
          {risk.health_score != null && (
            <p className="text-sm text-muted-foreground mt-1">Health: {risk.health_score}/100</p>
          )}
          <div className="mt-4 space-y-3 text-sm">
            <p><span className="font-semibold text-red-700 dark:text-red-400">Reason:</span> {risk.reason}</p>
            {!compact && risk.narrative && (
              <p className="whitespace-pre-wrap text-foreground">{risk.narrative}</p>
            )}
            <p><span className="font-semibold">Evidence:</span> {risk.evidence}</p>
            <p className="text-primary"><span className="font-semibold">Recommended action:</span> {risk.recommended_action}</p>
          </div>
        </div>
      ))}

      {!compact && data.generated_at && (
        <p className="text-xs text-muted-foreground">
          Generated {new Date(data.generated_at).toLocaleString()}
        </p>
      )}
    </div>
  );
};

export default RiskAssessmentView;
